import { Injectable } from '@angular/core';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import {
  IPostFiskalizacijaAkcijaDto,
  IVelicinaPapiraDto,
} from '@kodit/core/data-api';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class PostAkcijaFiskalizacijaFormService {
  constructor(private _fb: FormBuilderTypeSafe) {}

  public GetPostakcijaFisakalizacijaForm(
    model?: IPostFiskalizacijaAkcijaDto
  ): FormGroupTypeSafe<IPostFiskalizacijaAkcijaDto> {
    return this._fb.group<IPostFiskalizacijaAkcijaDto>({
      opis: new FormControl(model?.opis),
      postFiskalizacijeAkcija: new FormControl(model?.postFiskalizacijeAkcija),
      postFiskalizacijeAkcijaStr: new FormControl(
        model?.postFiskalizacijeAkcijaStr
      ),
    });
  }
}
